import actions from 'redux-auto'
import i18n from 'i18next'
import Api from '#services/api'

export function pending(state) {
  return {
    ...state,
  }
}

export function fulfilled(state, payload, result) {
  const nextState = {...state}
  nextState.activities = {
    ...state.activities,
    [payload.chatId]: result,
  }

  return {
    ...nextState,
  }
}

export function rejected(state) {
  return {
    ...state,
  }
}

export async function action(payload) {
  try {
    return await Api.getChatActivities(payload.chatId)
  } catch (e) {
    actions.error.writeError({error: e})
    throw new Error(i18n.t(e.message))
  }
}
